import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";
import { set } from "date-fns";
// import { element } from "prop-types";

class Sustancias extends React.Component {
  constructor(props) {
    super(props);
    this.handleModalSustancia = this.handleModalSustancia.bind(this);
    this.handleDesactivarSustancia = this.handleDesactivarSustancia.bind(this);
    this.handelModificarSustancia = this.handelModificarSustancia.bind(this);
    this.handleClickEditar = this.handleClickEditar.bind(this);
    this.handleSustanciasPage = this.handleSustanciasPage.bind(this);

    this.addEspecie = this.addEspecie.bind(this);
    this.removeEspecie = this.removeEspecie.bind(this);

    this.addCategoria = this.addCategoria.bind(this);
    this.removeCategoria = this.removeCategoria.bind(this);

    this.resetROElements = this.resetROElements.bind(this);
    this.forbiddenType = this.forbiddenType.bind(this);
    this.controlledType = this.controlledType.bind(this);
    this.resetCategoriaSelect = this.resetCategoriaSelect.bind(this);

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
      workingGrid: false,
      buscar: {},
      ingredientes: [],
      paginas: 0,
      registros: 0,
      paginaActual: 0,

      especie: {
        id: "0",
        descripcion: "",
      },
      tipo_control_id: "",
      categoriaTemp: "",
      categoria: {
        id: "0",
        descripcion: "",
      },
      ingrediente_id: "0",
      ingrediente: "",
      sustancia: {},
      categoriaEspecie: [], //todas las categorias según la especie
      grupoCategoria: {
        especie_id: "0",
        especie_descripcion: "",
        categoria_id: "0",
        categoria_descripcion: "",
      }, //guardo de categoria segun la especie
      grupoCategorias: [],
      especies: Api.loadCatalogue("cat_especie"),
      rel_categoria: {},
      especies_ids: {},
    };
  }

  form_ControlyEspecie = "";
  form_ResolucionyEliminar = "";

  my_grid = "";
  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setSustanciasPage(1);

    let categorias = [];

    /* let grid = {
      source: "app/getSustancias",
      target: "#t_sustancias",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nombre: {
          label: "Nombre",
        },
        tipo_control: {
          label: "Tipo control",
          render: (me) => {
            if (me.data.tipo_control === false) {
              me.innerHTML = "Normal";
            } else {
              me.innerHTML = me.data.tipo_control;
            }
          },
        },
        especies: {
          label: "Especie",
          render: (me) => {
            if (me.data.especies === false) {
              me.innerHTML = "-";
            } else {
              me.innerHTML = me.data.especies;
            }
          },
        },
        categorias: {
          label: "Categoría",
          render: (me) => {
            if (me.data.categorias === false) {
              me.innerHTML = "-";
            } else {
              me.innerHTML = me.data.categorias;
            }
          },
        },
        resolucion: {
          label: "Resolución",
          render: (me) => {
            if (me.data.resolucion === false) {
              me.innerHTML = "-";
            } else {
              me.innerHTML = me.data.resolucion;
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-pencil-alt",
          btnClass: "btn bg-gradient-yellow",
          btnTitle: "Modificar sustancia",
          btnClick: (data) => {
            this.setState({
              tipo_control_id: data.tipo_control_id,
              // grupoCategorias: [],
            });

            if (data.categoria_id === null) {
              data.categoria_id = "0";
            }

            if (data.tipo_control_id === null) {
              data.tipo_control_id = "0";
              let elementos = document.querySelectorAll(".roEelement");
              elementos.forEach((el) => el.setAttribute("disabled", true));
            } else if (data.tipo_control_id === "1") {
              this.forbiddenType();
            } else {
              this.controlledType();
            }

            if (data.especie_id === null) {
              data.especie_id = "0";
            }
            this.handleModalSustancia(data);
            this.form_ResolucionyEliminar.querySelector(
              "#eliminar_control"
            ).value = data.id;
            this.setState({
              ingrediente_id: data.id,
              ingrediente: data.nombre,
            });

            this.resetROElements();
          },
          render: (me, data) => {},
        },
      ],
    };
    this.mi_grid = Api.grid(grid); */

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "especie_id":
            let option_c = `<option value="0">Seleccione categorías</option>`;
            let nV = 0; //checho si realmente no esta la especie
            for (let c in categorias) {
              if (categorias[c].especie_id === me.value) {
                option_c += `<option value="${categorias[c].id}">${categorias[c].descripcion}</option>`;
                nV = 1;
              }
            }

            if (!nV && me.value !== "0") {
              //si especieno encuentra concidencias
              option_c = `<option value="0">Seleccione categoría</option>`;
            }
            busqueda.querySelector("#categoria_id").innerHTML = option_c;
            break;
          default:
        }

        //this.mi_grid.go(1, serial);
      },
      render: (form) => {
        /** Cargamos el combo de tipo control */
        let tipo_control = Api.loadCatalogue("cat_tipo_control");
        let option_tc =
          "<option value=0>Seleccione el tipo de control</option>";
        for (let t in tipo_control) {
          option_tc += `<option value="${tipo_control[t].id}">
                ${tipo_control[t].descripcion}
            </option>`;
        }
        form.querySelector("#tipo_control_id").innerHTML = option_tc;
        /* Fin de la carga control */

        /** Cargamos el combo de especies */
        let especies = this.state.especies;
        let especies_ids = [];
        let option_e = "<option value=0>Seleccione especie</option>";
        for (let e in especies) {
          especies_ids.push(especies[e].id);
          option_e += `<option value="${especies[e].id}">${especies[e].descripcion}</option>`;
        }
        this.setState({especies_ids: especies_ids});
        form.querySelector("#especie_id").innerHTML = option_e;
        /* Fin de la carga especies */

        /**  Cargamos el combo de especies */
        Api.fetch("cat/getEspecieCategoria").then((data) => {
          if (data) {
            this.setState({rel_categoria: data.categorias});
            categorias = data.categorias;
            let option_c = `<option value="0">Seleccione categorías</option>`;
            for (let c in data.categorias) {
              option_c += `<option value="${data.categorias[c].id}">${data.categorias[c].descripcion}</option>`;
            }
            form.querySelector("#categoria_id").innerHTML = option_c;
          }
        });
        /* Fin de la carga categoría */
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nom_ingrediente",
            label: "Ingresa el nombre del ingrediente",
            placeHolder: "Nombre ingrediente",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            name: "tipo_control_id",
            label: "Tipo control",
            placeHolder: "Tipo control",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            name: "especie_id",
            label: "Especie",
            placeHolder: "Especie",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            name: "categoria_id",
            label: "Categoría",
            placeHolder: "Categoría",
            cols: 2,
            value: "",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscar",
            text: "Buscar",
            icon: "fa fa-search",
            class: "form-control  btn-warning ",
            click: (me) => {
              this.setState({ buscar: busqueda.data() });
              this.setSustanciasPage(1);
            },
          },
        }
      ],
    });

    /**DEFINO MI FORMA SUSTANCIA */
    let formaControlyEspecie = {
      target: "#f_ControlyEspecie",
      nombre: "controlyEspecie",
      elementClass: "form-control",
      elements: [
        {
          select: {
            cols: 12,
            name: "tipo_control_id",
            label: "Tipo de control:",
          },
        },
        {
          select: {
            cols: 6,
            name: "especie_id",
            label: "Especie:",
            disabled: true,
            class: "form-control roEelement",
          },
        },
        {
          select: {
            cols: 4,
            name: "categoria_id",
            label: "Categoría:",
            disabled: true,
            class: "form-control roEelement",
          },
        },
        {
          button: {
            name: "mas",
            class: "form-control btn-primary roEelement",
            cols: 2,
            disabled: true,
            text: "+",
            value: 0,
            click: (me, data) => {
              let e_id =
                this.form_ControlyEspecie.querySelector("#especie_id").value;

              let e = this.state.especies.find(
                (d) => d.id === e_id //trae la descripcion
              );
              let e_descripcion = e !== undefined ? e.descripcion : "";

              let c_id =
                this.form_ControlyEspecie.querySelector("#categoria_id").value;
              let c_descripcion = "";

              for (let c in categorias) {
                if (
                  categorias[c].especie_id === e_id &&
                  categorias[c].id === c_id
                ) {
                  c_descripcion = categorias[c].descripcion;
                  break;
                }
              }

              if (c_descripcion === "Seleccione") {
                c_descripcion = "";
              }

              let obj = {
                especie_id: e_id,
                especie_descripcion: e_descripcion,
                categoria_id: c_id,
                categoria_descripcion: c_descripcion,
              };

              this.addEspecie(obj);
            },
          },
        },
      ],
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "tipo_control_id":
            this.setState({ tipo_control_id: me.value });
            if (me.value === "1") {
              let obj = {
                especie_id: data.tipo_control_id,
                especie_descripcion: "Todas las especies",
                categoria_id: "0",
                categoria_descripcion: "",
              };
              let gp = [];
              gp.push(obj);
              this.setState({ grupoCategorias: gp });
            } else {
              this.setState({ grupoCategorias: [] });
            }
            this.resetCategoriaSelect();
            this.resetROElements(me.value);
            break;
          case "especie_id":
            /**CAMBIAR DE CATEGORIA SEGÚN LA ESPECIE */
            let option_c = `<option value="0">Seleccione categoría</option>`;
            let nV = 0; //checho si realmente no esta la especie
            for (let c in categorias) {
              if (categorias[c].especie_id === me.value) {
                option_c += `<option value="${categorias[c].id}">${categorias[c].descripcion}</option>`;
                nV = 1;
              }
            }

            if (!nV) {
              //si especie encuentra concidencias
              option_c = `<option value="0">Seleccione categoría</option>`;
            }
            this.form_ControlyEspecie.querySelector("#categoria_id").innerHTML =
              option_c;

            /**FIN */
            break;

          case "categoria_id":
            this.setState({ categoriaTemp: me.value });
            break;

          default:
        }
      },
      render: (me) => {
        /** CARGO TIPO CONTROL */
        let tipo_control = Api.loadCatalogue("cat_tipo_control");
        let option_tc =
          "<option value=0 disabled selected>Seleccione el tipo de control</option>";
        for (let t in tipo_control) {
          option_tc += `<option value="${tipo_control[t].id}">
              ${tipo_control[t].descripcion}
          </option>`;
        }
        me.querySelector("#tipo_control_id").innerHTML = option_tc;
        /** CARGO LA ESPECIE */
        let especies = Api.loadCatalogue("cat_especie");
        especies = especies.filter((obj) => obj.id !== "1");
        let grupotpl =
          "<option value=0 disabled selected>Seleccione especie</option>";
        for (let e in especies) {
          grupotpl += `<option value="${especies[e].id}" descripcion="${especies[e].descripcion}">
                ${especies[e].descripcion}
            </option>`;
        }
        me.querySelector("#especie_id").innerHTML = grupotpl;
        /** CARGO LA CATEGORIA */
        // Api.fetch("cat/getEspecieCategoria").then((data) => {
        //   if (data) {
        //     categorias = data.categorias;
        let option_c = `<option value="0" disabled selected>Seleccione categoría</option>`;
        // for (let c in categorias) {
        //   option_c += `<option value="${categorias[c].id}">${categorias[c].descripcion}</option>`;
        // }
        me.querySelector("#categoria_id").innerHTML = option_c;

        //     this.setState({
        //       categoriaEspecie: data.categorias,
        //     });
        //   }
        // });
      },
    };
    this.form_ControlyEspecie = Api.form(formaControlyEspecie);

    let formaResolucionyEliminar = {
      target: "#f_ResolucionyEliminar",
      nombre: "resolucionyEliminar",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "resolucion",
            label: "Resolución",
            value: " ",
            cols: 12,
          },
        },
        {
          button: {
            name: "eliminar_control",
            class: "form-control btn btn-lg btn-danger",
            cols: 12,
            text: "Eliminar control",
            value: 0,
            click: (me, data) => {
              this.handleDesactivarSustancia();
            },
          },
        },
        {
          button: {
            name: "regresar",
            class: "form-control btn btn-lg btn-white",
            cols: 6,
            text: "Regresar",
            value: 0,
            click: (me, data) => {
              this.modalSus.close();
              this.setSustanciasPage(1);
            },
          },
        },
        {
          button: {
            name: "modificar",
            class: "form-control btn btn-lg btn-green",
            cols: 6,
            text: "Modificar",
            value: 0,
            click: (me) => {
              let data = {
                ingrediente_id: this.state.ingrediente_id,
                tipo_control_id:
                  this.form_ControlyEspecie.data().tipo_control_id,
                especiesyCategorias: this.state.grupoCategorias,
                resolucion: this.form_ResolucionyEliminar.data().resolucion,
              };

              this.handelModificarSustancia(data);
            },
          },
        },
      ],
      onchange: (me, data, serial) => {},
      render: (me) => {},
    };
    this.form_ResolucionyEliminar = Api.form(formaResolucionyEliminar);
  }

  setSustanciasPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getSustancias?page=" + page + src).then((i) => {
      this.setState({
        ingredientes: i.data,
        paginas: i.last_page,
        registros: i.total,
        paginaActual: i.current_page,
        workingGrid: false,
      });
    });
  }

  handleSustanciasPage(e) {
    this.setSustanciasPage(e.target.value);
  }

  handleClickEditar(e, data){
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      tipo_control_id: data.tipo_control_id,
    });

    if (data.categoria_id === null) {
      data.categoria_id = "0";
    }

    if (data.tipo_control_id === null) {
      data.tipo_control_id = "0";
      let elementos = document.querySelectorAll(".roEelement");
      elementos.forEach((el) => el.setAttribute("disabled", true));
    } else if (data.tipo_control_id === "1") {
      this.forbiddenType();
    } else {
      this.controlledType();
    }

    if (data.especie_id === null) {
      data.especie_id = "0";
    }
    this.handleModalSustancia(data);
    this.form_ResolucionyEliminar.querySelector(
      "#eliminar_control"
    ).value = data.id;
    this.setState({
      ingrediente_id: data.id,
      ingrediente: data.nombre,
    });

    this.resetROElements();
  }

  modalSus = {};
  handleModalSustancia(dataForm) {
    Api.loading(true);
    let detalle = document.querySelector("#detalleSustancia");
    let data = {};
    this.form_ControlyEspecie.merge(dataForm);

    /**Inicializo el estado de especies */
    Api.fetch(
      "app/getIngredienteEspecie?ingrediente_id=" + dataForm.id + "&"
    ).then((e) => {
      this.setState({ grupoCategorias: e.data });

      let especie_remover = detalle.querySelectorAll(".remover-especie");

      especie_remover.forEach((esp) => {
        esp.addEventListener("click", this.removeEspecie);
      });
      data = {
        ingrediente_id: this.state.ingrediente_id,
        tipo_control_id: this.form_ControlyEspecie.data().tipo_control_id,
        especiesyCategorias: this.state.grupoCategorias,
        resolucion: this.form_ResolucionyEliminar.data().resolucion,
      };

      this.setState({
        sustancia: data,
      });
      Api.loading(false);
    });

    /**Si es nueva sustancia no muestra el boton */
    Api.fetch("app/esNuevo?ingrediente_id=" + dataForm.id + "&").then((e) => {
      if (e) {
        this.form_ResolucionyEliminar.querySelector(
          ".eliminar_control"
        ).classList = "form-group eliminar_control";
      }else{
        this.form_ResolucionyEliminar.querySelector(
          ".eliminar_control"
        ).classList = "form-group hide eliminar_control";
      }
    });

    this.form_ResolucionyEliminar.merge(dataForm);

    //inicializo sustancia

    /*Abrimos el modal */
    this.modalSus = Api.modal({
      title: "Control de sustancia: " + dataForm.nombre,
      html: detalle,
    });
  }

  handelModificarSustancia(dataForm) {
    let pass = 1;

    if (dataForm.resolucion === " " || !dataForm.resolucion) {
      Swal.fire({
        title: "Error",
        icon: "warning",
        text: "Favor de ingresar la resolución.",
      });
      pass = 0;
    }

    if (dataForm.especiesyCategorias.length === 0) {
      Swal.fire({
        title: "Error",
        icon: "warning",
        text: "Favor de ingresar la especie.",
      });
      pass = 0;
    }

    if (dataForm.tipo_control_id === "0") {
      Swal.fire({
        title: "Error",
        icon: "warning",
        text: "Favor de ingresar el tipo de control.",
      });
      pass = 0;
    }

    if (pass) {
      Api.loading(true);
      return Api.fetch(
        "app/modificarSustancia",
        {
          ingrediente_id: dataForm.ingrediente_id,
          resolucion: dataForm.resolucion,
          tipo_control_id: dataForm.tipo_control_id,
          especieYcategoria: dataForm.especiesyCategorias,
        },
        "POST"
      ).then((r) => {
        Swal.fire({
          icon: "success",
          title: "Sustancia modificada con éxito.",
          //text: r.message,
        }).then(() => {
          this.modalSus.close();
          this.setState()
          Api.loading(false);
          this.setSustanciasPage(1);
          //this.mi_grid.go(1);
        });
      });
    }
  }

  handleDesactivarSustancia() {
    Swal.fire({
      icon: "question",
      title: "¿Seguro que desea eliminar control?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        return Api.fetch(
          "app/deactivateSustancia",
          {
            ingrediente_id: this.state.sustancia.ingrediente_id,
            resolucion: this.state.sustancia.resolucion,
            tipo_control_id: this.state.sustancia.tipo_control_id,
            especieYcategoria: this.state.sustancia.especiesyCategorias,
          },
          "PUT"
        ).then((r) => {
          Swal.fire({
            icon: "success",
            title: "Sustancia modificada con éxito.",
            //text: r.message,
          }).then(() => {
            this.modalSus.close();
            Api.loading(false);
            this.setSustanciasPage(1);
            //window.location = "/sustancias";
          });
        });
      }
    });
  }

  addEspecie(e) {
    let obj_ec = e; //nuevo valor
    let pa = [...this.state.grupoCategorias];
    //let noCategoria = [1, 5, 6, 7];
    let noCategoria = this.especieCategoria();

    let todas = this.state.grupoCategorias.filter(function (cat) {
      return cat.especie_id === "1";
    });

    if (obj_ec.especie_id === "0") {
      // si no ingresa una especie no agrega
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de seleccionar al menos una especie",
      });
      return false;
    } else {
      // si es != 0
      if (todas.length !== 0) {
        //encontro  todas las especies en el estado
        Swal.fire({
          title: "Atención",
          icon: "warning",
          text: "Ya se agregaron todas las especies.",
        });
        return false;
      }
      let encuentra = noCategoria.indexOf(parseInt(obj_ec.especie_id)); //te regresa el index
      if (encuentra >= 1) {
        //entra a no categoria
        //comparamos si esta en la lista
        for (let re in this.state.grupoCategorias) {
          if (pa[re].especie_id === obj_ec.especie_id) {
            Swal.fire({
              title: "Atención",
              icon: "warning",
              text: "Ya cuenta con esta categoría en su lista.",
            });
            return false;
          }
        }

        pa.push(obj_ec);
        this.setState({
          grupoCategorias: pa,
        });
      } else if (encuentra === 0) {
          //si es TODAS LAS ESPECIES
          //vacio el estado por que no puede compartir especie
          this.setState({
            grupoCategoria: {
              categoria_id: "0",
              categoria_descripcion: "",
              especie_id: "0",
              especie_descripcion: "",
            },
            grupoCategorias: [],
          });

          pa = [...this.state.grupoCategorias];
          pa.push(obj_ec);
          this.setState({
            grupoCategorias: pa,
          });
      } else {
        if (obj_ec.categoria_id !== "0") {
          for (let re in this.state.grupoCategorias) {
            if (pa[re].categoria_id === obj_ec.categoria_id) {
              Swal.fire({
                title: "Atención",
                icon: "warning",
                text: "Ya cuenta con esta categoría en su lista.",
              });
              return false;
            }
          }
          pa.push(obj_ec);
          this.setState({
            grupoCategorias: pa,
          });

          this.resetCategoriaSelect();
          this.resetROElements();
        } else {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Favor de seleccionar la categoría",
          });
          return false;
        }
      }
    }

    this.setState({ grupoCategoria: e });

    // asigno el boton de remove cada ves que agrego un boton
    let detalle = document.querySelector("#detalleSustancia");
    let especie_remover = detalle.querySelectorAll(".remover-especie");

    especie_remover.forEach((esp) => {
      esp.addEventListener("click", this.removeEspecie);
    });
  }

  removeEspecie(e) {
    let lista_especies = [...this.state.grupoCategorias];
    lista_especies.splice(e.target.id, 1);
    this.setState({ grupoCategorias: lista_especies });
  }

  especieCategoria = () => {
    let conCategoria = [];
    let rel = [... this.state.rel_categoria];
    for(let c in rel){
      if(!conCategoria.includes(rel[c].especie_id)) conCategoria.push(rel[c].especie_id);
    }

    let especie = [... this.state.especies_ids];
    let sinCategoria = [];
    for(let i in especie){
      if(!conCategoria.includes(especie[i])) sinCategoria.push(parseInt(especie[i]));
    }

    return sinCategoria;
  }

  resetROElements(tipo_control_id) {
    if (tipo_control_id === "2") {
      document
        .querySelectorAll(".roEelement")
        .forEach((el) => el.removeAttribute("disabled"));
    } else if (tipo_control_id === "1") {
      document
        .querySelectorAll(".roEelement")
        .forEach((el) => el.setAttribute("disabled", true));
    }

    if (this.state.tipo_control_id !== "2") {
      this.form_ControlyEspecie.querySelector("#especie_id").value = 0;
    }
    this.form_ControlyEspecie.querySelector("#categoria_id").value = 0;
  }

  resetCategoriaSelect() {
    if (this.state.tipo_control_id !== "2") {
      let c_options = this.form_ControlyEspecie.querySelector("#categoria_id");
      c_options.innerHTML = `<option value="0">Seleccione categoría</option>`;
    }
  }

  forbiddenType(e) {
    let elementos = document.querySelectorAll(".roEelement");
    elementos.forEach((el) => el.setAttribute("disabled", true));
  }

  controlledType(e) {
    let elementos = document.querySelectorAll(".roEelement");
    elementos.forEach((el) => el.removeAttribute("disabled"));
  }

  addCategoria(e) {
    let cat = this.state.categoria;
    let pa = this.state.categorias;

    if (cat.id !== 0 && cat.descripcion !== "") {
      for (let re in this.state.categorias) {
        if (pa[re].id === cat.id) {
          Swal.fire({
            title: "Atención",
            icon: "warning",
            text: "Ya cuenta con esta categoría en su lista.",
          });
          return false;
        }
      }

      pa.push(cat);
      this.setState({
        categorias: pa,
        categoria: this.state.categoria,
      });
    }
  }
  removeCategoria(e) {}

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Inicio
          </li>
          <li className="breadcrumb-item active">Sustancias</li>
        </ol>
        <h1 className="page-header">Sustancias</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                {/* <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="t_sustancias"></div> */}
                {/* EMPIEZA LA TABLA */}
              <div className="table-responsive">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">NOMBRE</th>
                      <th className="text-center">TIPO CONTROL</th>
                      <th className="text-center">ESPECIE</th>
                      <th className="text-center">CATEGORÍA</th>
                      <th className="text-center">RESOLUCIÓN</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.ingredientes && this.state.ingredientes.length > 0 ? (
                      this.state.ingredientes.map((ing) => (
                        <tr>
                          <td>{ing.nombre}</td>
                          <td>{ing.tipo_control}</td>
                          <td>{ing.especies}</td>
                          <td>{ing.categorias}</td>
                          <td>{ing.resolucion}</td>
                          <td className="text-center">
                              <button
                                onClick={(e) => this.handleClickEditar(e, ing)}
                                id={"button_ing_" + ing.id}
                                data-ingente-id={ing.id}
                                className="btn bg-gradient-yellow"
                                title="Modificar sustancia"
                              >
                                <i
                                  id={"i_ing_" + ing.id}
                                  data-ingente-id={ing.id}
                                  className="fa fa-pencil-alt"
                                ></i>
                              </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setSustanciasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setSustanciasPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setSustanciasPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setSustanciasPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleSustanciasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
                {/* TERMINA LA TABLA */}
                <div className="hide">
                  <div id="detalleSustancia">
                    <Panel>
                      <PanelBody>
                        <div id="f_ControlyEspecie"></div>
                        <div className="table-responsive">
                          <table className="table table-striped m-b-0 table-hover">
                            <thead>
                              <tr>
                                <th>Especie</th>
                                <th>Categoria</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.grupoCategorias.length !== 0 ? 
                              <>
                                {this.state.grupoCategorias.map(
                                  (especie, index) => (
                                    <tr key={index} id={index}>
                                      <td>{especie.especie_descripcion}</td>
                                      <td>{especie.categoria_descripcion}</td>
                                      {this.state.tipo_control_id !== "1" ? (
                                        <td className="text-right">
                                          <button
                                            className="btn btn-warning remover-especie"
                                            id={index}
                                            title="Remover especie y categoría"
                                            data-especie_id={especie.especie_id}
                                            data-categoria_id={
                                              especie.categoria_id
                                            }
                                            onClick={this.removeEspecie}
                                          >
                                            <i
                                              className="fas fa-trash"
                                              id={index}
                                              data-especie_id={especie.especie_id}
                                              data-categoria_id={
                                                especie.categoria_id
                                              }
                                              onClick={this.removeEspecie}
                                            ></i>
                                          </button>
                                        </td>
                                      ) : (
                                        <td></td>
                                      )}
                                    </tr>
                                  )
                                )}</>
                                :  <>
                                <td></td>
                                <td></td>
                                <td>No hay especies en la lista</td>
                                </>
                              }
                            </tbody>
                          </table>
                        </div>
                        <div id="f_ResolucionyEliminar"></div>
                      </PanelBody>
                    </Panel>
                  </div>
                </div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default Sustancias;
